import { Backdrop, CircularProgress } from '@mui/material';
import { ReactElement } from 'react';

interface ILoadingOverlayProps {
  isOpen?: boolean;
}

export const LoadingOverlay = (props: ILoadingOverlayProps): ReactElement => {
  const { isOpen } = props;

  return (
    <Backdrop sx={{ backgroundColor: '#bfcdd4', color: '#007bbd' }} open={isOpen}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};
